<template>
    <div class="modal-card">
        <section class="modal-card-body">
            <h3 class="title has-text-centered">Forgot password?</h3>
            <div class="box">
                    <span class="has-text-centered">ENTER THE EMAIL ADDRESS YOU HAVE REGISTERED WITH US.</span>
                    <b-field>
                        <b-input v-model="user.email" type="email" placeholder="Email Address">
                        </b-input>
                    </b-field>
                    <button class="button is-large is-fullwidth is-primary" @click="resetPassword()">
                      Send
                    </button>
                </div>
				<div class="has-text-centered">
					<a class="has-text-link" @click="backToLogin()">Back to Login</a>
				</div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'PasswordForgot',
  data () {
    return {
      user: {}
    }
  },
  computed: {
    ...mapGetters([
      'base_url'
    ])
  },
  methods: {
    resetPassword(){
      this.$parent.close()
      axios.post(`${this.base_url}accounts/password/reset/`, this.user)
        .then(response => {
          console.log(response.data)
          this.$router.push({path: '/'});
        })
        .catch(error => {
          console.log(error.response.data)
          this.$toast.open({
            type: 'is-danger',
            icon: 'error_outline',
            message: `Something went wrong! Please contact the administrator!`,
            duration: 5000,
            position: "is-top"
          });
        });
    },
    backToLogin() {
      this.$parent.close()
      this.$router.push({path: 'Login'});
    }
  }
}
</script>

<style scoped>
.password-remind-link {
	margin-bottom: 10px;
}
.background-light {
	background-color: hsl(0, 0%, 96%);
}
</style>

